import { Directive, ElementRef, HostListener, Inject, Input } from "@angular/core";
import { CountryCode } from "@app/models/CountryCode";
import { formatPhoneNumberForInput, limitPhoneNumberLengthForInput } from "./phone-number-formatters";
import { NgControl } from "@angular/forms";

// exported for mocking
export const util = {
    isMaybeSamsungDevice(): boolean {
        const agent = typeof window !== 'undefined' && window instanceof Window && window.navigator.userAgent
        return agent && /Linux/.test(agent)
    }
}

@Directive({
    selector: '[phone-number]'
})
export class PhoneNumberDirective {
    @Input() countryCode: CountryCode;

    constructor(@Inject(NgControl) private control: NgControl,
                @Inject(ElementRef) private $el: ElementRef) {}

    @HostListener('input', ['$event']) onInputChange(event?) {

        const formattedValue = this.formatPhoneNumber(this.$el.nativeElement.value);
        this.control.viewToModelUpdate(formattedValue)
        this.$el.nativeElement.value = formattedValue;

    }

    private formatPhoneNumber(value: any) {

        const output = value.replace(new RegExp(/[^\d]/, 'g'), ''); // Remove every non-digit character

        /** Country codes USA an CAN should not mask */
        const isActiveMask = () => /^(USA|CAN)$/i.test(this.countryCode.code);

        const valueCheckedForInputLength  = limitPhoneNumberLengthForInput(output, this.countryCode.code, this.countryCode.value);

        if (!isActiveMask()) {
            return valueCheckedForInputLength;
        }

        return formatPhoneNumberForInput(valueCheckedForInputLength, this.countryCode.code);
    }
}
